(function (angular, window) {
    'use strict';

    /**
     * Gets the list of Services that are attached to the service type.
     */
    window.THF.Angular.API
        .factory('BankModel', ['$http', '$q', function ($http, $q) {
            var BankModel = function () {

            };

            BankModel.prototype = {
                bsbCheck: function (bsb) {
                    var deferred = $q.defer();
                    var req = {
                        method: 'GET',
                        url: '/api/v1/data/banks/'+bsb
                    };

                    $http(req)
                        .success(function (response) {
                            deferred.resolve(response);
                        })
                        .error(function () {
                            deferred.reject();
                        });
                    return deferred.promise;
                }
            };

            return new BankModel();
        }]);

})(angular, window);
